import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { AppNotification } from '@app/helpers';
import { AuthService, BrokerService, ClientService, ConductService, LocalStorageService, SurveyService } from '@app/services';
import { ConductListTableConfig } from '@app/views/conduct/conduct-list/conduct-list.table-config';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  currentUserRole: any;
  currentUser: any;
  
  isLoading: boolean = false;


  constructor(
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.getUser()
  }

  getUser() {
    this.authService.me().subscribe({
      next: (res: any) => {
        this.currentUser = res.data
      },
      error: console.log
    })
  }

  saveProfile() {
    this.isLoading = true
    this.authService.saveProfile({
      firstName: this.currentUser.firstName,
      lastName: this.currentUser.lastName,
      phone: this.currentUser.phone
    }).subscribe({
      next: (res: any) => {},
      error: console.log,
      complete: ()=>{
        this.isLoading = false
      }
    })
  }

  currentPassword: any = "";
  newPassword: any = "";
  confirmNewPassword: any = "";

  resetPassword() {
    if(this.newPassword != this.confirmNewPassword) {
      AppNotification.error('new password and confirm must be same!')
      return
    }
    this.isLoading = true
    this.authService.setPassword({
      currentPassword: this.currentPassword,
      newPassword: this.newPassword,
    }).subscribe({
      next: (res: any) => {
        this.newPassword = "";
        this.currentPassword = ""
        this.confirmNewPassword = ""
        AppNotification.success('Password changed!')
        this.isLoading = false
      },
      error: (res: any) => {
        AppNotification.error(res?.error?.data)
        this.isLoading = false
      }
    })
  }
}
